import { FetchAttributeProps } from '../../types'
import { optionsAdapter } from './adapter'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { FetchCollectionParams, FetchCreatedAtParams, httpService, UpdateEntityProps } from '../../../services/_common'
import { parseHttpError } from '../../utils'
import { parseOptions } from './utils'
import { TApiOption } from '../../../services/product/types'
import { selectors } from './selectors'
import { productService } from '../../../services/product'
import { IOption, OptionProps, TOptionsState } from '../../types'


const name = 'options'

const initialState: TOptionsState = {
    ...optionsAdapter.getInitialState(),
    isFetching: false,
    totalItems: 0,
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async (params: FetchCreatedAtParams & FetchCollectionParams | undefined) => {
        return httpService.fetchCollection<TApiOption, IOption, FetchAttributeProps>({
            url: '/options',
            params,
            parseFunction: parseOptions
        })
    },
    {
        serializeError: parseHttpError
    }
)

const create = createAsyncThunk(
    `${name}/create`,
    async (option: OptionProps) => {
        return await productService.createOption(option)
    },
    {
        serializeError: parseHttpError
    }
)

const update = createAsyncThunk(
    `${name}/create`,
    async (option: UpdateEntityProps<OptionProps>) => {
        return await productService.updateOption(option)
    },
    {
        serializeError: parseHttpError
    }
)

const remove = createAsyncThunk(
    `${name}/remove`,
    async (id: string) => {
        return await productService.removeOption(id)
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                state.totalItems = action.payload.totalItems
                optionsAdapter.setAll(state, action.payload.entities)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const options = {
    name: slice.name,
    actions: {
        fetch,
        create,
        update,
        remove,
    },
    reducer: slice.reducer,
    selectors,
}